import {axios} from '@/api/axios';
import {PLAYER_CONFIG_URLS} from '@/api/urls';
import {formatString} from '@/utils';
import {PlayerConfig} from '@/types/player-config';

export const PlayerConfigApi = {
  getList: () => axios.get<PlayerConfig[]>(PLAYER_CONFIG_URLS.GET_LIST),
  getByTicketCategory: (id: string) => axios.get<PlayerConfig>(formatString(PLAYER_CONFIG_URLS.GET_BY_CATEGORY, id)),
  getOne: (PlayerConfigId: string) => axios.get<PlayerConfig>(formatString(PLAYER_CONFIG_URLS.GET_ONE, PlayerConfigId)),

  save: (data: PlayerConfig) => axios.post<PlayerConfig>(PLAYER_CONFIG_URLS.SAVE, data),
  bulkSave: (data: PlayerConfig[]) => axios.post<PlayerConfig>(PLAYER_CONFIG_URLS.BULK_SAVE, {bulk: data}),
  edit: (PlayerConfigId: string, data: PlayerConfig) => axios.put<PlayerConfig>(formatString(PLAYER_CONFIG_URLS.EDIT, PlayerConfigId), data),
  delete: (PlayerConfigId: string) => axios.delete<PlayerConfig>(formatString(PLAYER_CONFIG_URLS.EDIT, PlayerConfigId))
};
